import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getCompanies,
  getCompaniesForCertificateForTeam,
  getCompanyById,
  resendTenantInvitation,
} from "./TenantTeamApi";

const initialState: any = {
  loading: {
    get_all: false,
    get_by_id: false,
    invitation: false,
  },
  req_success: {
    get_all: false,
    get_by_id: false,
  },
  current_page: 0,
  company_certificate_for_team_table_current_page:0,
  all_tenants: [],
  current_tenant: [],
  temp_tenants: [],
  tenants: [],
  all_company_certificate_for_team:[],
  company_certificate_for_team:[],
  temp_company_certificate_for_team:[]
};

const TenantSlice = createSlice({
  name: "TenantSlice",
  initialState,
  reducers: {
    tenantTablePaginate: (state: any, { payload }: PayloadAction<any>) => {
      if (payload === 0) {
        state.current_page = 0;
        state.tenants = state.all_tenants.slice(payload, 10);
      } else if (payload === 1) {
        state.current_page = 1;
        state.tenants = state.all_tenants.slice(payload * 10, 10 * 2);
        state.current_page = payload;
      } else {
        state.current_page = payload;
        state.tenants = state.all_tenants.slice(
          payload * 10,
          10 * payload + 10,
        );
      }
    },
    searchTenantInTable: (state: any, { payload }: PayloadAction<any>) => {
      if (payload.length >= 1) {
        state.temp_tenants = state.all_tenants.filter((tenant: any) =>
          tenant.name.includes(payload?.toLowerCase()),
        );
        state.tenants = state.temp_tenants.slice(0, 10);
      } else {
        state.tenants = state.all_tenants.slice(
          state.current_page * 10,
          10 * state.current_page + 10,
        );
      }
    },
    companyForCertificateForPaginate: (state: any, { payload }: PayloadAction<any>) => {
      if (payload === 0) {
        state.company_certificate_for_team_table_current_page = 0;
        state.company_certificate_for_team = state.all_company_certificate_for_team.slice(payload, 10);
      } else if (payload === 1) {
        state.company_certificate_for_team_table_current_page = 1;
        state.company_certificate_for_team = state.all_company_certificate_for_team.slice(payload * 10, 10 * 2);
        state.company_certificate_for_team_table_current_page = payload;
      } else {
        state.company_certificate_for_team_table_current_page = payload;
        state.company_certificate_for_team = state.all_company_certificate_for_team.slice(
          payload * 10,
          10 * payload + 10,
        );
      }
    },
    searchCompanyForCertifiacteForTeamTable: (state: any, { payload }: PayloadAction<any>) => {
      if (payload.length >= 1) {
        state.temp_company_certificate_for_team = state.all_company_certificate_for_team.filter((tenant: any) =>
         {
          return  tenant.company_name.includes(payload?.toLowerCase()) || tenant.email.includes(payload?.toLowerCase())
         },
        );
        state.company_certificate_for_team = state.temp_company_certificate_for_team.slice(0, 10);
      } else {
        state.company_certificate_for_team = state.all_company_certificate_for_team.slice(
          state.current_page * 10,
          10 * state.current_page + 10,
        );
      }
    },
  },
  extraReducers: (builder) => {
    // GET All Tenants
    builder.addCase(getCompanies.pending, (state) => {
      state.loading.get_all = true;
      state.req_success.get_all = false;
    });
    builder.addCase(
      getCompanies.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_all = false;
        state.req_success.get_all = true;
        state.all_tenants = payload.data;
        state.tenants = state.all_tenants.slice(0, 10);
      },
    );
    builder.addCase(getCompanies.rejected, (state) => {
      state.loading.get_all = false;
    });

    // GET a tenant by Id
    builder.addCase(getCompanyById.pending, (state) => {
      state.loading.get_by_id = true;
      state.req_success.get_by_id = false;
    });
    builder.addCase(
      getCompanyById.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_by_id = false;
        state.req_success.get_by_id = true;
        state.current_tenant = payload.data;
      },
    );
    builder.addCase(getCompanyById.rejected, (state) => {
      state.loading.get_by_id = false;
    });
    builder.addCase(resendTenantInvitation.pending, (state) => {
      state.loading.invitation = true;
    });
    builder.addCase(resendTenantInvitation.fulfilled, (state) => {
      state.loading.invitation = false;
    });
    builder.addCase(resendTenantInvitation.rejected, (state) => {
      state.loading.invitation = false;
    });
        // GET All Tenants
        builder.addCase(getCompaniesForCertificateForTeam.pending, (state) => {
          state.loading.get_all = true;
          state.req_success.get_all = false;
        });
        builder.addCase(
          getCompaniesForCertificateForTeam.fulfilled,
          (state, { payload }: PayloadAction<any>) => {
            state.loading.get_all = false;
            state.req_success.get_all = true;
            state.all_company_certificate_for_team = payload;
            state.company_certificate_for_team = state.all_company_certificate_for_team.slice(0, 10);
          },
        );
        builder.addCase(getCompaniesForCertificateForTeam.rejected, (state) => {
          state.loading.get_all = false;
        });
  },
});
export const { tenantTablePaginate, searchTenantInTable,companyForCertificateForPaginate,searchCompanyForCertifiacteForTeamTable} = TenantSlice.actions;
export default TenantSlice.reducer;
